function initializeClickEventListeners() {
	const elementsToTrack = [
		{
			selector: '.announcement-bar',
			itemSelector: '.announcement-bar__item',
			eventType: 'announcement',
		},
		{
			selector: '.carousel__wrapper swiper-wrapper',
			itemSelector: '.carousel__slide swiper-slide',
			eventType: 'select_item',
		},
		{
			selector: '.slideshow__inner',
			itemSelector: '.slideshow-slide',
			eventType: 'select_promotion',
		},
		{
			selector: '.complete-the-look__products',
			itemSelector: '.product-card-mini',
			eventType: 'select_item',
		},
		{
			selector: '.drawer-menu__primary-links',
			itemSelector: '.drawer-menu__item',
			eventType: 'header',
		},
	];

	elementsToTrack.forEach(({ selector, itemSelector, eventType }) => {
		const wrapper = document.querySelector(selector);
		if (wrapper) {
			wrapper.addEventListener('click', (event) => {
				const clickedItem = event.target.closest(itemSelector);
				if (clickedItem) {
					switch (eventType) {
						case 'announcement':
							pushAnnouncementBarDataLayer(clickedItem);
							break;
						case 'add_to_cart':
						case 'select_item':
							pushDataLayer(eventType, clickedItem, 'isProductItem');
							break;
						case 'select_promotion':
							pushPromotionDataLayer(clickedItem.dataset, eventType);
							break;
						case 'header':
							pushHeaderDataLayer(clickedItem);
							break;
						default:
					}
				}
			});
		}
	});
}

document.addEventListener('DOMContentLoaded', initializeClickEventListeners);

// General pushDataLayer function
const pushDataLayer = (eventName, event, config = {}) => {
	const eventDetail = event.dataset;
	let dataLayerObject;
	if (config === 'isProductItem') {
		dataLayerObject = formatDataLayerObject(eventName, eventDetail);
		if (eventDetail.sectionName === 'drawer_search') {
			const searchQuery = document.getElementById('search').value;
			dataLayerObject.search_query = searchQuery;
		}
	}
	if (config === 'select_item') {
		dataLayerObject = event;
	}
	const dataLayerEntry = {
		event: eventName,
		...dataLayerObject,
		...config.additionalFields,
	};
	window.dataLayer.push(dataLayerEntry);
};

// Expose pushDataLayer globally for use in other scripts
window.pushDataLayer = pushDataLayer;

function pushHeaderDataLayer(event) {
	// Ensure event and dataset exist, otherwise use empty object as fallback
	const data = event?.dataset || {};
	pushDataLayer('Header Menu', event, {
		additionalFields: {
			name: 'header_menu',
			header_main_label: data?.menuHandle || 'NA',
			header_category: data?.menuCategory || 'NA',
			header_sub_category: data?.menuSubCategory || 'NA',
		},
	});
}

// Function to format data layer object based on event type
function formatDataLayerObject(eventName, eventDetail) {
	const baseItem = {
		item_id: eventDetail.itemId || 'NA',
		item_name: eventDetail.itemTitle || 'NA',
		affiliation: eventDetail.itemVendor || 'NA',
		index: eventDetail.index || 0,
		item_brand: eventDetail.itemBrand || 'NA',
		item_category: eventDetail.itemCategory || 'NA',
		item_category2: eventDetail.itemCategory2 || 'NA',
		item_category3: eventDetail.itemCategory3,
		item_category4: eventDetail.itemCategory4,
		item_category5: eventDetail.itemCategory5,
		item_list_id: eventDetail.sectionId || 'NA',
		item_list_name: eventDetail.sectionName || 'NA',
		item_variant: eventDetail.itemVariant || '',
		price: Number(eventDetail.itemPrice) || 0,
		quantity: Number(eventDetail.itemQuantity) || 1,
	};

	const dataLayerObject = {
		ecommerce: {
			items: [baseItem],
		},
	};

	if (eventName === 'add_to_cart') {
		dataLayerObject.ecommerce.add_to_cart_type = eventDetail.cartType || 'NA';
		dataLayerObject.ecommerce.currency = 'ILS';
		dataLayerObject.ecommerce.value = baseItem.price * baseItem.quantity;
	}

	return dataLayerObject;
}

const pushFilterSortingDataLayer = (event) => {
	pushDataLayer('Filter Products', event, {
		additionalFields: {
			name: 'filter_products',
			filter_type: event.dataset.filterType || 'NA',
			filtering_type: event.dataset.filterName || 'NA',
			sorting_type: event.dataset.sortType || 'NA',
		},
	});
};

function pushPromotionDataLayer(eventDetail, eventName) {
	pushDataLayer(
		eventName,
		{ dataset: eventDetail },
		{
			additionalFields: {
				ecommerce: {
					creative_name: eventDetail.creativeName || 'NA',
					creative_slot: eventDetail.creativeSlot || 'NA',
					promotion_id: eventDetail.promotionId || 'NA',
					promotion_name: eventDetail.promotionName || 'NA',
				},
			},
		}
	);
}

function pushAnnouncementBarDataLayer(event) {
	pushDataLayer('Announcement Bar', event, {
		additionalFields: {
			name: 'announcement_bar',
			announcement: event.dataset.slideTitle || 'NA',
		},
	});
}

function pushFooterDataLayer(event) {
	pushDataLayer('Footer menu', event, {
		additionalFields: {
			name: event.dataset.eventName || 'NA',
			footer_label: event.dataset.label || 'NA',
		},
	});
}

// Check visibility and push data to the data layer
function checkVisibilityAndPushData(targetSelector, eventType, itemSelector) {
	const targetElement = document.querySelector(targetSelector);
	let hasExecuted = false;
	function checkVisibility() {
		if (!targetElement || hasExecuted) {
			return;
		}

		const { top, bottom } = targetElement.getBoundingClientRect();
		const isVisible = top >= 0 && bottom <= window.innerHeight;

		if (!isVisible) {
			return;
		}

		const itemsArray = Array.from(document.querySelectorAll(itemSelector)).map((item) => {
			return eventType === 'view_promotion'
				? {
						creativeName: item.dataset.creativeName || 'NA',
						creativeSlot: item.dataset.creativeSlot || 'NA',
						promotionId: item.dataset.promotionId || 'NA',
						promotionName: item.dataset.promotionName || 'NA',
				  }
				: formatDataLayerObject(eventType, item.dataset).ecommerce.items[0];
		});

		if (eventType === 'view_promotion') {
			itemsArray.forEach((item) => pushPromotionDataLayer(item, eventType));
		} else {
			const ecommerce = {
				items: itemsArray,
			};
			pushDataLayer(eventType, { ecommerce: ecommerce }, 'select_item');
		}
		hasExecuted = true;
		window.removeEventListener('scroll', checkVisibility);
	}

	window.addEventListener('scroll', checkVisibility);
}

// Initialize visibility checks
checkVisibilityAndPushData(
	'.featured-collection-slider',
	'view_item_list',
	'.featured-collection-slider__product'
);

checkVisibilityAndPushData('.complete-the-look__products', 'view_item_list', '.product-card-mini');

checkVisibilityAndPushData('.slideshow__carousel', 'view_promotion', '.slideshow-slide');

/**
 * Send quick cart data to data layer (similar to cart page)
 * This function is called when the quick cart opens
 */
function sendQuickCartData() {
	const cartItems = document.querySelectorAll('.quick-cart__item');
	const itemsArray = Array.from(cartItems).map((item) => {
		const eventDetail = item.dataset;
		return formatDataLayerObject('view_cart', eventDetail).ecommerce.items[0];
	});

	if (itemsArray.length > 0) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'view_cart',
			ecommerce: {
				items: itemsArray,
			},
		});
	}
}

// Listen for quick cart open event to send view_cart data
document.addEventListener('quick-cart:open', function (evt) {
	sendQuickCartData();
});
